/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ct_Fiverr_TaglineInputs */

const en_ct_fiverr_tagline = /** @type {(inputs: Ct_Fiverr_TaglineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trusted by ${i?.count} clients worldwide`)
};

const ar_ct_fiverr_tagline = /** @type {(inputs: Ct_Fiverr_TaglineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`موثوق من ${i?.count} عميلًا حول العالم`)
};

const bn_ct_fiverr_tagline = /** @type {(inputs: Ct_Fiverr_TaglineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`বিশ্বজুড়ে ${i?.count} জন ক্লায়েন্টের আস্থা`)
};

const de_ct_fiverr_tagline = /** @type {(inputs: Ct_Fiverr_TaglineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Weltweit von ${i?.count} Kunden geschätzt`)
};

const es_ct_fiverr_tagline = /** @type {(inputs: Ct_Fiverr_TaglineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La confianza de ${i?.count} clientes en todo el mundo`)
};

const fr_ct_fiverr_tagline = /** @type {(inputs: Ct_Fiverr_TaglineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Approuvé par ${i?.count} clients dans le monde`)
};

const pt_ct_fiverr_tagline = /** @type {(inputs: Ct_Fiverr_TaglineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A confiança de ${i?.count} clientes em todo o mundo`)
};

const zh_ct_fiverr_tagline = /** @type {(inputs: Ct_Fiverr_TaglineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`受到全球 ${i?.count} 个客户的信赖`)
};

const tr_ct_fiverr_tagline = /** @type {(inputs: Ct_Fiverr_TaglineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dünya çapında ${i?.count} müşteri tarafından güveniliyor`)
};

const ru_ct_fiverr_tagline = /** @type {(inputs: Ct_Fiverr_TaglineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Нам доверяют ${i?.count} клиентов по всему миру`)
};

const pl_ct_fiverr_tagline = /** @type {(inputs: Ct_Fiverr_TaglineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zaufało nam ${i?.count} klientów na całym świecie`)
};

/**
* | output |
* | --- |
* | "Trusted by {count} clients worldwide" |
*
* @param {Ct_Fiverr_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const ct_fiverr_tagline = /** @type {((inputs: Ct_Fiverr_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ct_Fiverr_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ct_fiverr_tagline(inputs)
	if (locale === "bn") return bn_ct_fiverr_tagline(inputs)
	if (locale === "de") return de_ct_fiverr_tagline(inputs)
	if (locale === "es") return es_ct_fiverr_tagline(inputs)
	if (locale === "fr") return fr_ct_fiverr_tagline(inputs)
	if (locale === "pt") return pt_ct_fiverr_tagline(inputs)
	if (locale === "zh") return zh_ct_fiverr_tagline(inputs)
	if (locale === "tr") return tr_ct_fiverr_tagline(inputs)
	if (locale === "ru") return ru_ct_fiverr_tagline(inputs)
	if (locale === "pl") return pl_ct_fiverr_tagline(inputs)
	return en_ct_fiverr_tagline(inputs)
});